export default __webpack_public_path__ + "static/media/10.110c7d2f.jpg";